import { ArrowUpRight, Linkedin, Mail, Phone } from "lucide-react";
import { profile } from "../../data/portfolio";
import { Reveal } from "./Reveal";
import { Monogram, scrollTo } from "./Header";

export default function Contact() {
  return (
    <footer id="contact" data-testid="contact-section" className="relative pt-32 md:pt-44 pb-12 overflow-hidden">
      <div className="absolute rounded-full mix-blend-multiply blur-3xl opacity-60 bg-sage w-[30rem] h-[30rem] -bottom-40 left-1/4 pointer-events-none" />
      <div className="absolute rounded-full mix-blend-multiply blur-3xl opacity-50 bg-blush w-[26rem] h-[26rem] top-10 -left-32 pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-6 md:px-10">
        <Reveal>
          <p className="eyebrow mb-6 flex items-center gap-3">
            <span className="inline-block w-10 h-px bg-fog/50" />
            Contact
          </p>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 data-testid="contact-heading" className="font-display font-light tracking-tighter leading-[1.02] text-ink text-5xl sm:text-6xl lg:text-8xl max-w-4xl">
            Let's turn evidence<br />
            <span className="italic text-fog">into impact — together.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.2}>
          <div className="mt-12 md:mt-16 flex flex-wrap items-center gap-4">
            <a
              data-testid="contact-email-button"
              href={`mailto:${profile.email}`}
              className="group inline-flex items-center gap-3 rounded-full bg-ink text-paper px-6 md:px-9 py-4 md:py-5 text-[13px] md:text-base font-medium tracking-wide transition-[background-color,transform] duration-300 hover:bg-[#3d453f] hover:-translate-y-0.5"
            >
              <Mail className="w-4 h-4" />
              {profile.email}
              <ArrowUpRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </a>
            <a
              data-testid="contact-linkedin-button"
              href={profile.linkedin}
              target="_blank"
              rel="noopener noreferrer"
              className="glass glass-hover inline-flex items-center gap-3 rounded-full px-8 py-5 text-sm md:text-base font-medium text-ink"
            >
              <Linkedin className="w-4 h-4" /> LinkedIn
            </a>
            <a
              data-testid="contact-phone-button"
              href={`tel:${profile.phoneHref}`}
              className="glass glass-hover inline-flex items-center gap-3 rounded-full px-8 py-5 text-sm md:text-base font-medium text-ink"
            >
              <Phone className="w-4 h-4" /> {profile.phone}
            </a>
          </div>
        </Reveal>

        <div className="mt-24 md:mt-32 pt-8 border-t border-stone/70 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-5">
          <button data-testid="footer-logo" onClick={() => scrollTo("#top")} className="flex items-center gap-3 text-ink">
            <Monogram className="w-8 h-8" />
            <span className="font-display text-base font-medium">Dr. Vishakha Dhivar</span>
          </button>
          <p className="text-xs tracking-wide text-fog">
            {profile.location} · © {new Date().getFullYear()} — Research Associate & Physician
          </p>
        </div>
      </div>
    </footer>
  );
}
